import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'

export const initBasicMap = async (container, center) => {
  const config = useRuntimeConfig()
  const map = shallowRef(null)
  map.value = new maplibregl.Map({
    container: container,
    style: {
      version: 8,
      name: 'WNI Simple',
      sources: {
        simple: { type: 'vector', url: `${config.public.mapDomain}/json/japan/admin/latest.json` }
      },
      glyphs: `${config.public.wxTechDomain}/map/font/openmaptiles/{fontstack}/{range}.pbf`,
      layers: [
        {
          id: 'background',
          type: 'background',
          paint: {
            'background-color': '#b3d1ff'
          }
        },
        {
          'id': 'land',
          'source': 'simple',
          'source-layer': 'pref',
          'type': 'fill',
          'paint': {
            'fill-color': 'rgb(245, 245, 245)'
          }
        }
      ]
    },
    localIdeographFontFamily: '"Noto Sans", "Noto Sans CJK SC", sans-serif',
    center: center,
    zoom: 4,
    attributionControl: false,
    boxZoom: false,
    doubleClickZoom: false,
    dragPan: false,
    dragRotate: false,
    keyboard: false,
    scrollZoom: false,
    touchPitch: false,
    touchZoomRotate: false
  })
  map.value.once('load', () => {
    map.value.addSource('pref-tile', {
      type: 'vector',
      url: `${config.public.mapDomain}/json/japan/admin/latest.json`
    })
    map.value.addLayer({
      'id': 'pref-boundary',
      'type': 'line',
      'source': 'pref-tile',
      'source-layer': 'pref',
      'paint': {
        'line-color': '#303030',
        'line-width': 0.5
      }
    })
  })
  return map.value
}
